import config from '../../config/config';
import Head from 'next/head';
import Banner from '../../components/Proyecto/Banner/Banner';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import BackButton from '../../components/Proyecto/BackButton/BackButton';
import { FaWhatsapp, FaInstagram, FaBehance } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { Fragment, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import s from '../../components/Proyecto/slug.module.scss';
import { FB_EVENTS, sendPixelEvent } from '../../services/facebook';

export default function Project({ data }) {
    const social = [
        {
            href: "https://wa.link/zzpw1g",
            iconComp: <FaWhatsapp size={30} style={{ color: '#ff7700' }} />
        },
        {
            href: "https://www.instagram.com/whereismybrand.mx/",
            iconComp: <FaInstagram size={30} style={{ color: '#ff7700' }} />
        },
        {
            href: "mailto:info@whereismybrand.mx",
            iconComp: <IoMdMail size={30} style={{ color: '#ff7700' }} />
        },
        {
            href: "https://www.behance.net/whereismybrand?tracking_source=search_users%7Cwhere%20is%20my%20brand",
            iconComp: <FaBehance size={30} style={{ color: '#ff7700' }} />
        },
    ]

    const router = useRouter();

    const [proyectos, setProyectos] = useState([]);
    const [currentIndex, setCurrentIndex] = useState();

    const parsedDescription = {
        __html: data?.descripcion
    };

    const chunks = (a, size) =>
        Array.from(
            new Array(Math.ceil(a.length / size)),
            (_, i) => a.slice(i * size, i * size + size)
        );


    const galerias = chunks(data.carousel, 3);

    useEffect(() => {
        getAllSlugs();
    }, []);

    useEffect(() => {
        getAllSlugs();
    }, [router]);

    async function getAllSlugs() {
        let res = await fetch(config().apiUrl + '/proyectos?sort=createdAt:desc');
        let innerData = await res.json();

        //filter anuncios
        let filter = innerData?.data.filter(item => item.es_anuncio == false);
        let slugs = filter.map(item => {
            return item.slug;
        });
        setProyectos(slugs);
        for (let [index, item] of slugs.entries()) {
            if (item === data.slug) {
                setCurrentIndex(index);
            }
        }
    }

    const next = () => {
        if (currentIndex + 1 < proyectos.length) {
            router.push(`/portafolio/${proyectos[currentIndex + 1]}`);
        }
        else {
            router.push(`/portafolio/${proyectos[0]}`);
        }
    }

    const previous = () => {
        if (currentIndex - 1 < 0) {
            router.push(`/portafolio/${proyectos[proyectos.length - 1]}`);
        }
        else {
            router.push(`/portafolio/${proyectos[currentIndex - 1]}`);
        }
    }

    const capi = async (socialLink) => {
        if(socialLink.indexOf('wa.link') > -1) {
            await sendPixelEvent(FB_EVENTS.lead);
        }
    }

    return (
        <>
            <Head>
                <title>{data.nombre} | Where is my brand?</title>
                <meta name="description" content={data.nombre} />
                <link rel="icon" href="/favicon.png" />
            </Head>
            <Navbar />
            <BackButton />

            <div className="container mt-5 mb-3 my-md-5">
                <div className="row pt-2 pt-md-4">
                    <div className="col-md-3 mt-2 mt-md-0">
                        <img src={config().assetUrl + (data?.logo?.formats?.small?.url || data?.logo?.url)} className="d-block w-75" alt="logo" />
                    </div>
                    <div className="col-md-3 my-4 my-md-0 d-block d-md-none">
                        {
                            data?.categorias?.map(cat => (
                                <p key={`m-${cat?.id}`} className='fs-6 mb-0'>{cat?.nombre}</p>
                            ))
                        }
                    </div>
                    <div className="col-md-3 my-4 my-md-0 d-none d-md-block">
                        {
                            data?.categorias?.map(cat => (
                                <p key={`d-${cat?.id}`} className='fs-5 mb-0'>{cat?.nombre}</p>
                            ))
                        }
                    </div>
                    <div className="col-md-6 fs-6 text-justify d-block d-md-none" dangerouslySetInnerHTML={parsedDescription}>
                    </div>
                    <div className="col-md-6 fs-5 text-justify d-none d-md-block" dangerouslySetInnerHTML={parsedDescription}>
                    </div>
                </div>
            </div>
            {/* <div className='container my-5'>
                <div className='row'>
                    <div className='col-md-12'>
                        <Banner project={data} />
                    </div>
                </div>
            </div> */}
            <div className='container mb-5 mt-0 my-md-5'>
                <div className='row'>
                    <div className='col-md-12'>
                        {galerias.map((galeria, outerIndex) => (
                            <div className={s['grid-container']} key={outerIndex}>
                                {
                                    galeria.map((item, index) => (
                                        <Fragment key={`item-${index}`}>
                                            {index === 0 && <img src={config().assetUrl + item.url} className={s.full} />}
                                            {index === 1 && <img src={config().assetUrl + item.url} className={s.half1} />}
                                            {index === 2 && <img src={config().assetUrl + item.url} className={s.half2} />}
                                        </Fragment>
                                    ))
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className='container my-5'>
                <div className='row'>
                    <div className='col-md-4'>
                        <button className={s.back_button} onClick={previous}>
                            <img className={s.back} src='/arrow-right.png' />
                            BACK
                        </button>
                    </div>
                    <div className='col-md-8'>
                        <button className={s.forward_button} onClick={next}>
                            NEXT
                            <img className={s.forward} src='/arrow-right-white.png' />
                        </button>
                    </div>
                </div>
            </div>
            <div className={s.social__container}>
                {
                    social.map((item, i) => (
                        <a
                            key={`social-${i}`}
                            href={item.href}
                            target={"_blank"}
                            rel="noreferrer"
                            className={`${s.sn__icon}`}
                            aria-label="redes sociales"
                            onClick={() => capi(item.href)}
                        >
                            {item.iconComp}
                        </a>
                    ))
                }
            </div>
            <Footer />
        </>
    )
}

export async function getStaticPaths() {
    const paths = await getAllProjects();
    return {
        paths,
        fallback: 'blocking'
    };
}

export async function getStaticProps({ params }) {
    let { slug } = params;
    let res = await fetch(config().apiUrl + '/proyectos?populate=*&filters[slug][$eq]=' + slug);
    let resJson = await res.json();
    let data = resJson?.data[0];

    return {
        props: {
            data
        },
        revalidate: 300
    };
}

async function getAllProjects() {
    let res = await fetch(config().apiUrl + '/proyectos?populate=*');
    let data = await res.json();

    //filter anuncios
    let filter = data?.data.filter(item => item.es_anuncio == false);
    let paths = filter.map(item => {
        return {
            params: {
                slug: item.slug
            }
        }
    });
    return paths;
}